import { PropertyRatesDefaultersComponent } from './property-rates-defaulters/property-rates-defaulters.component'
import { BusinessLicenceDefaultersComponent } from './business-licence-defaulters/business-licence-defaulters.component'
import { BusinessBookReportsComponent } from './business-book-reports/business-book-reports.component'
import { RateBookReportsComponent } from './rate-book-reports/rate-book-reports.component'
import { CommercialLicenseReportsComponent } from './commercial-license-reports/commercial-license-reports.component'
import { RdnReportsComponent } from './rdn-reports/rdn-reports.component'
import { ReportsComponent } from './reports.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from '@guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const ReportsRoutes: Routes = [
  {
    path: 'reports',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'REPORTS_DASHBOARD',
        redirectTo: '/',
      },
    },
    children: [
      { path: '', component: ReportsComponent },
      { path: 'rdn', component: RdnReportsComponent },
      {
        path: 'commercial-license',
        component: CommercialLicenseReportsComponent,
      },
      {
        path: 'rate-book',
        component: RateBookReportsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: 'REPORTS_BOOKS',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'business-book',
        component: BusinessBookReportsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: 'REPORTS_BOOKS',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'property-rates-defaulters',
        component: PropertyRatesDefaultersComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: 'BIG_REPORTS',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'business-licence-defaulters',
        component: BusinessLicenceDefaultersComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: 'BIG_REPORTS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
